module.exports = __webpack_public_path__ + "img/VRP_Logo_EMS.0643b374.png";